import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { QButton } from '@kw/quokka-ui';
import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { BackgroundProgressBar } from '../../BackgroundProgressBar/BackgroundProgressBar';
import { ApplicationsPopover } from '../ApplicationsPopover';
import { Link } from '../../../Link';

interface IProps {
  appAnalysis: any;
  appDetails: any;
  fetchDeniedApps: () => void;
  fetchTrustedApps: () => void;
  showDeniedApps: boolean;
  backQParams?: string;
  setPdfOptionsOpen?: (open: boolean) => void;
  analysisId: string;
}

export function ActionsButtonHeader({
  appAnalysis,
  appDetails,
  fetchDeniedApps,
  fetchTrustedApps,
  showDeniedApps,
  backQParams,

  setPdfOptionsOpen,
  analysisId,
}: IProps) {
  const [actionButtonAnchorEl, setActionButtonAnchorEl] = useState(null);
  const [actionPopoverIsOpen, setActionPopoverIsOpen] = useState(false);

  const handleActionButtonPopoverClick = (event: { currentTarget: HTMLButtonElement | HTMLAnchorElement } = null) => {
    setActionButtonAnchorEl(event.currentTarget);
    setActionPopoverIsOpen(true);
  };

  const handlePopoverClose = () => {
    setActionButtonAnchorEl(null);
    setActionPopoverIsOpen(false);
  };

  const backUrl = backQParams ? `/applications?${backQParams}` : '/applications';

  return (
    <>
      <BackgroundProgressBar />
      <StyledButtonContainer>
        <StyledBackButton href={backUrl}>
          <StyledArrowBack />
          <StyledBackText>Back to Applications</StyledBackText>
        </StyledBackButton>
        <StyledQButton endIcon={<KeyboardArrowDownIcon />} variant="filled" onClick={event => handleActionButtonPopoverClick(event)}>
          Actions
        </StyledQButton>
      </StyledButtonContainer>
      <ApplicationsPopover
        applicationId={appDetails.appId}
        os={appDetails.os}
        name={appDetails.appName}
        isOpen={actionPopoverIsOpen}
        anchorEl={actionButtonAnchorEl}
        handleClose={handlePopoverClose}
        fetchDeniedApps={fetchDeniedApps}
        fetchTrustedApps={fetchTrustedApps}
        showDeniedApps={showDeniedApps}
        setPdfOptionsOpen={setPdfOptionsOpen}
        isDenied={appAnalysis.isDenied}
        isTrusted={appAnalysis.isAllowed}
        analysisId={analysisId}
      />
    </>
  );
}

/** styles */

const StyledButtonContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const StyledQButton = styled(QButton)`
  margin-left: auto;
  min-width: 110px;
`;

const StyledBackButton = styled(Link)`
  display: flex;
  height: 30px;
  padding-left: 18px;
  padding-right: 22px;
  column-gap: 11px;
  width: 200px;
  border-radius: 4px;
  margin-bottom: 7px;

  align-items: center;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.grey[800]};

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[200]};
  }
`;

const StyledBackText = styled('div')`
  font-size: 13px;
  line-height: 13px;
`;

const StyledArrowBack = styled(ArrowBackIcon)`
  width: 16px;
`;
